import useDropdownMenu from "./useDropdownMenu";
import React, {useEffect, useRef} from "react";
import ReactDOM from "react-dom";
import {menuPortalEl} from "../../Providers/LayoutProvider";
import {DropdownMenuType} from "./DropdownMenuTypes";

const DropdownMenu = (props: DropdownMenuType) => {
    const menuRef = useRef<HTMLDivElement>(null);
    const { menuData, targetRef, updateMenuRef } = useDropdownMenu(props);

    useEffect(() => {
        if(props.activationCallBack && menuData.open && targetRef.current) {
            props.activationCallBack(targetRef.current);
        }
    }, [menuData, targetRef]);

    useEffect(() => {
        if(props.toggleCallback) {
            props.toggleCallback();
        }
    }, [menuData.open]);

    useEffect(() => {
        updateMenuRef(menuRef.current);
    },[menuRef]);

    return (
        <>
            {ReactDOM.createPortal (
                <div
                    ref={menuRef}
                    className={`item-menu-container ${menuData.open ? 'open' : ''} ${menuData.positionClass ? menuData.positionClass : ''}`}
                    style={{ position: 'absolute', top: menuData.y, left: menuData.x, zIndex: props.forcedZIndexNumber ?? 10000 }}
                >
                    {props.children}
                </div>,
                menuPortalEl
            )}
        </>
    )
};

export default DropdownMenu